import * as React from 'react'
import { SpinnerWrapper, StyledSpinner } from './style'

interface BodySpinnerProps {
  height?: number
}

// TODO: pass props for legend or action probably?
const BodySpinner: React.FunctionComponent<BodySpinnerProps> = ({ height }) => (
  // @ts-ignore
  <SpinnerWrapper height={height}>
    <StyledSpinner />
  </SpinnerWrapper>
)

export default BodySpinner
